// @flow

import type {Node as MarkdocAstNode} from '@stripe-internal/markdoc';
import type {Config as MarkdocConfig} from 'docs/markdoc/types';
import type {CodeGeneratorSnippetArgs} from '../../../../../server/services';

export const REPLACEMENT_KEY = '$$TEST_KEY_REPLACE_ME$$';
export const REPLACEMENT_API_VERSION = '$$API_VERSION_REPLACE_ME$$';

export const BETA_LANGUAGES = ['curl', 'ruby', 'python', 'php', 'node'];

export const LANGUAGES = [
  'curl',
  'cli',
  'ruby',
  'python',
  'php',
  'java',
  'node',
  'go',
  'dotnet',
];

export const codegenNodeToCodegenArgs = (
  node: MarkdocAstNode,
  config: MarkdocConfig,
): CodeGeneratorSnippetArgs => {
  const attributes: {
    path: string,
    method: string,
    args: any,
    gated: ?Array<string>,
    betaHeader: ?string,
  } = (node.attributes: any);

  // This resolves args like $merchant.currency to be
  // the value in the config
  const resolvedArgs: any = node.resolve(attributes.args, config);

  const requestArgs: CodeGeneratorSnippetArgs = {
    test_key: REPLACEMENT_KEY,
    path: attributes.path,
    verb: attributes.method.toLowerCase(),
    args: resolvedArgs,
    gated: attributes.gated || undefined,
    api_version: attributes.betaHeader
      ? `${REPLACEMENT_API_VERSION}; ${attributes.betaHeader}`
      : undefined,
  };

  return requestArgs;
};
